import { render } from "./403.html?vue&type=template&id=1ebdb2ad&scoped=true&ts=true"
import script from "./403.ts?vue&type=script&lang=ts"
export * from "./403.ts?vue&type=script&lang=ts"

import "./403.scss?vue&type=style&index=0&id=1ebdb2ad&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ebdb2ad"]])

export default __exports__